// Data pro Gastrofestival Cesta Kolem Světa - Nabídka pro město Luhačovice

export const festivalInfo = {
  name: "GASTROFESTIVAL \"CESTA KOLEM SVĚTA\"",
  subtitle: "Nabídka partnerské spolupráce",
  city: "Luhačovice",
  year: "2027",
  date: "Červen 2027",
  duration: "2 dny",
  expectedVisitors: "6 000 návštěvníků",
  dailyVisitors: "3 000 osob/den",
  eventId: "luhacovice-gastrofest-2027",
};

export const locationsConcept = {
  title: "Unikátní koncept: 3 lokace, 6 kontinentů",
  description: "Gastrofestival se rozloží do tří strategických míst v centru Luhačovic. Každá lokace bude reprezentovat dva světové kontinenty se stylovou výzdobou, autentickými kulináři a kuchařskými show.",
  
  locations: [
    {
      id: 1,
      name: "Před Klubem kultury",
      gps: { lat: 49.1009675, lng: 17.7590642 },
      continents: ["Evropa", "Amerika"],
      description: "Evropské speciality a americké street food",
      features: [
        "Italská pasta a pizza",
        "Francouzské delikatesy",
        "Americké burgery a BBQ",
        "Mexické tacos"
      ],
      show: "Kuchařská show každý den v 14:00"
    },
    {
      id: 2,
      name: "Náměstí 28. října",
      gps: { lat: 49.1014453, lng: 17.7607808 },
      continents: ["Asie", "Afrika"],
      description: "Asijské chutě a africké speciality",
      features: [
        "Vietnamské phở a banh mi",
        "Japonské sushi a ramen",
        "Thajské kari a pad thai",
        "Africké BBQ"
      ],
      show: "Kuchařská show každý den v 15:00"
    },
    {
      id: 3,
      name: "Dr. Veselého",
      gps: { lat: 49.1015558, lng: 17.7599789 },
      continents: ["Austrálie & Oceánie", "Jižní Amerika"],
      description: "Exotika ze světových koutů",
      features: [
        "Australské klokaní maso",
        "Argentinské steaky",
        "Brazilské churrasco",
        "Peruánské ceviche"
      ],
      show: "Kuchařská show každý den v 16:00"
    }
  ],
  
  visitorExperience: [
    "Interaktivní mapa festivalu s popisem kontinentů",
    "Stylová výzdoba každé lokace v duchu kontinentů",
    "Průvodce světovými chutěmi zdarma",
    "Kuchařské show v každé lokaci",
    "Doprovodný kulturní program"
  ]
};

export const programHighlights = [
  "3 festivalové zóny v centru města",
  "Prezentace všech 6 kontinentů",
  "Kuchařské show v každé lokaci",
  "Živá hudba a kulturní program",
  "Bohatý program pro děti",
  "Ochutnávky ze světa",
  "Soutěže v pojídání",
  "Škola vaření pro děti"
];

export const sampleProgram = {
  title: "Vzorový program festivalu",
  subtitle: "Reference z Gastrofestivalu Uherské Hradiště 2026 (Budget varianta)",
  note: "💎 Pro Luhačovice můžeme sestavit i prémiovou variantu s hvězdnými kuchaři a celebritami!",
  
  categories: [
    {
      title: "🎤 Hudba a zpěv",
      icon: "Music",
      performers: [
        {
          name: "Alžběta Kolečkářová",
          description: "Finalistka SuperStar s charismatickým hlasem a energickým koncertem plným poprockových hitů"
        },
        {
          name: "Honza Grebík",
          description: "Populární zpěvák a kytarista, rozproudí dav známými českými i světovými hity"
        },
        {
          name: "DJ Spike",
          description: "Pořádná dávka taneční muziky a rytmů po celý festival"
        }
      ]
    },
    {
      title: "🎩 Show a zábava",
      icon: "Sparkles",
      performers: [
        {
          name: "Jiří Hadaš",
          description: "Profesionální kouzelník a iluzionista – zábava pro děti i dospělé"
        },
        {
          name: "Vašek Oboda (Hell's Kitchen Česko)",
          description: "BBQ cooking show plná ohně, kouře a masa, která vás nenechá chladnými"
        },
        {
          name: "Lukáš Neckář",
          description: "Sushi show a lekce přípravy barevného sushi přímo na pódiu"
        },
        {
          name: "Jaroslav Němec – Maxijedlík",
          description: "Rekordní výzva v pojídání cvrčků a žabích stehýnek"
        }
      ]
    },
    {
      title: "🍹 Bary a nápoje",
      icon: "Wine",
      items: [
        "Točené pivo z originálních německých bierwágenů",
        "Domácí limonády z čerstvých surovin",
        "Koktejly s letní atmosférou",
        "Vína mnoha druhů",
        "Nealko drinky pro řidiče a děti"
      ]
    }
  ]
};

export const worldCuisines = {
  title: "Cesta kolem světa na talíři",
  subtitle: "Ochutnejte autentické speciality ze všech kontinentů",
  
  continents: [
    {
      flag: "🇻🇳",
      name: "Vietnam",
      vendors: [
        {
          name: "Domovina Food Truck",
          location: "Brno",
          dishes: [
            {
              name: "Thịt Kho Tàu",
              description: "Karamelizovaný vepřový bůček s jasmínovou rýží, salátkem a nakládanou zeleninou",
              note: "Tradiční domácí recept z jihu Vietnamu"
            },
            {
              name: "Bún Chả",
              description: "Grilované vepřové maso, rýžové nudle, čerstvé bylinky, vietnamská zálivka",
              note: "Obědová klasika přímo z Hanoje"
            },
            {
              name: "Spicy Mayo Chicken",
              description: "Pikantní kuřecí maso s jemnou majonézou, čerstvou zeleninou a rýží",
              note: "Lehce pálivé, silně návykové"
            },
            {
              name: "Dim Sum knedlíčky",
              description: "Nadýchané knedlíčky plněné masem nebo zeleninou s omáčkou",
              vegan: false
            },
            {
              name: "Bún Chay",
              description: "Vegan verze rýžových nudlí s tofu, salátem a bylinkami",
              vegan: true
            }
          ]
        }
      ]
    },
    {
      flag: "🇺🇸",
      name: "Amerika & Kanada",
      vendors: [
        {
          name: "Různí dodavatelé",
          dishes: [
            { name: "Šťavnaté burgery", description: "Od oceněných mistrů grilu" },
            { name: "Smash burgery", description: "Ikonické tenké placky s kůrkou" },
            { name: "BBQ žebírka", description: "Trhané maso z americké udírny na dřevě" },
            { name: "Kanadský poutine", description: "Hranolky se sýrem a omáčkou gravy" },
            { name: "Lanýžové hranolky", description: "S pravým lanýžovým olejem" }
          ]
        }
      ]
    },
    {
      flag: "🇲🇽",
      name: "Mexiko",
      vendors: [
        {
          name: "Tož Tacos",
          dishes: [
            {
              name: "Tacos Auténticos",
              description: "S luxusním pomalu pečeným masem uzeným na americký způsob v marinádě Al Pastor"
            },
            {
              name: "Quesadillas",
              description: "S pravými mexickými salsami: pico de gallo, piňa a guacamole"
            }
          ]
        }
      ]
    },
    {
      flag: "🇪🇬",
      name: "Egypt",
      vendors: [
        {
          name: "Shams Bistro",
          dishes: [
            {
              name: "Hovězí Kofta",
              description: "Grilované hovězí s orientálním kořením, sezamový dip, egyptská nakládaná zelenina (pita nebo rýže)"
            },
            {
              name: "Kuřecí Shish Tawook",
              description: "Grilované kuřecí s dip z granátového jablka (pita nebo rýže)"
            },
            {
              name: "Egypt Mix",
              description: "Kombinace hovězí kofty a kuřecího shish tawook"
            },
            {
              name: "Vegan Mahshi",
              description: "Zelné a vinné listy plněné rýží a bylinkami",
              vegan: true
            },
            {
              name: "Baklava & Kunafa",
              description: "Sladké dezerty s oříšky a pistáciemi"
            },
            {
              name: "Káva na písku",
              description: "Tradiční arabská káva s kardamomem, připravená v džezvě na horkém písku"
            }
          ]
        }
      ]
    },
    {
      flag: "🇪🇸",
      name: "Španělsko",
      vendors: [
        {
          name: "Miquel Villarejo",
          dishes: [
            { name: "Paella s mořskými plody" },
            { name: "Paella Valenciana" },
            { name: "Slávky a la Mariniere" },
            { name: "Arros negro (černá rýže)" }
          ]
        }
      ]
    },
    {
      flag: "🇮🇩",
      name: "Indonésie",
      vendors: [
        {
          name: "Warung Indonesia",
          dishes: [
            {
              name: "Beef Rendang",
              description: "Nejlepší jídlo světa podle CNN Travel (2017)",
              highlight: true
            },
            {
              name: "Veganské speciality",
              description: "Plné chuti z kokosového mléka a rýžové mouky",
              vegan: true
            },
            {
              name: "Sladké dobroty",
              description: "Většina jídel bez lepku! Laděno pro každého, s možností přidat domácí sambal (chilli)"
            }
          ]
        }
      ]
    },
    {
      flag: "🇯🇵",
      name: "Japonsko",
      vendors: [
        {
          name: "Lukáš Neckář & Colorsushi",
          dishes: [
            { name: "Barevné sushi" },
            { name: "Sushi kurzy zdarma" },
            { name: "Ochutnávky přímo na místě" }
          ]
        }
      ]
    },
    {
      flag: "🇫🇷",
      name: "Francie",
      vendors: [
        {
          name: "Cheese Mafia La Familia",
          dishes: [
            {
              name: "Grilovaný Raclette",
              description: "Francouzský sýr servírovaný na farmářských brambůrkách s červenou cibulkou, pálivou klobásou a cornichonky"
            }
          ]
        },
        {
          name: "Šnečí farma Vlkoš",
          dishes: [
            { name: "Šnečí paštika" },
            { name: "Gratinovaní šnečci s česnekem" },
            { name: "Šneci v ulitách" }
          ]
        }
      ]
    },
    {
      flag: "🇬🇷",
      name: "Řecko",
      vendors: [
        {
          name: "Street food Gyradiko",
          owner: "Rodilý Řek Jannis",
          dishes: [
            { name: "Originální gyros z vepřového", description: "V čerstvé pitě, jako v Athénách" },
            { name: "Kuřecí souvlaki", description: "Se slaninou a tzatziki" },
            { name: "Halloumi sýr", description: "Dovezený přímo z Kypru" },
            { name: "Baklava & Galaktobureko", description: "Řecké dezerty" }
          ]
        }
      ]
    },
    {
      flag: "🇨🇿",
      name: "Česko – Morava",
      vendors: [
        {
          name: "Různí místní dodavatelé",
          dishes: [
            { name: "Grilovaná kolena, žebra, steaky" },
            { name: "Halušky, bramboráky, buřty" },
            { name: "Langoše, bramborové spirály" },
            { name: "Frgály, makovníky, trdelníky" },
            { name: "Moravské víno, sýry, kachní jatýrka" }
          ]
        },
        {
          name: "Moravský stánek paní Nejezchlebové",
          description: "Pečení na dřevem vytápěných kamnech jako kdysi. Čerstvé báleše a patenty připravované ženami v dobových krojích.",
          traditional: true
        }
      ]
    },
    {
      flag: "🐜",
      name: "Hmyzí speciality",
      vendors: [
        {
          name: "Crunchy & Grig",
          dishes: [
            { name: "Kobylky, červíci" },
            { name: "Hmyzí lízátka a čokoláda" }
          ]
        }
      ]
    },
    {
      flag: "🇹🇷",
      name: "Turecko",
      vendors: [
        {
          name: "Turecký stánek",
          dishes: [
            { name: "Döner kebab", description: "Grilované maso v pita chlebu s čerstvou zeleninou a omáčkami" },
            { name: "Lahmacun", description: "Turecká pizza s mletým masem a kořením" },
            { name: "Baklava", description: "Sladký dezert z listového těsta, oříšků a medu" },
            { name: "Türk kahvesi", description: "Tradiční silná turecká káva s kardamomem" }
          ]
        }
      ]
    },
    {
      flag: "🇮🇳",
      name: "Indie",
      vendors: [
        {
          name: "Indická kuchyně",
          dishes: [
            { name: "Tandoori chicken", description: "Kuře marinované v jogurtu a koření, pečené v tandoor peci" },
            { name: "Butter chicken", description: "Kuře v bohaté máslové rajčatové omáčce" },
            { name: "Samosas", description: "Smažené trojúhelníčky plněné kořeněnými bramborami nebo masem" },
            { name: "Naan chléb", description: "Tradiční indický chléb pečený v tandoor peci" },
            { name: "Mango lassi", description: "Osvěžující nápoj z mangového jogurtu" }
          ]
        }
      ]
    },
    {
      flag: "🇰🇷",
      name: "Korea",
      vendors: [
        {
          name: "K-Food stánek",
          dishes: [
            { name: "Bibimbap", description: "Miska s rýží, zeleninou, masem a pikantní omáčkou gochujang" },
            { name: "Korean BBQ", description: "Grilované marinované maso (bulgogi) servírované v salátu" },
            { name: "Kimchi", description: "Fermentovaná nakládaná zelenina - tradiční korejská příloha" },
            { name: "Tteokbokki", description: "Pikantní rýžové koláčky v červené chilli omáčce" }
          ]
        }
      ]
    },
    {
      flag: "🇲🇦",
      name: "Maroko",
      vendors: [
        {
          name: "Marocká kuchyně",
          dishes: [
            { name: "Tajine", description: "Dušené maso se zeleninou a sušeným ovocem v tradiční nádobě" },
            { name: "Couscous", description: "Kuskus s dušenou zeleninou a kořeněným masem" },
            { name: "Harira", description: "Hustá polévka s čočkou, cizrnou a kořením" },
            { name: "Marocký čaj", description: "Sladký zelený čaj s čerstvou mátou" }
          ]
        }
      ]
    },
    {
      flag: "🇵🇱",
      name: "Polsko",
      vendors: [
        {
          name: "Polský stánek",
          dishes: [
            { name: "Pierogi", description: "Tradiční plněné knedlíčky s bramborami, masem nebo sýrem" },
            { name: "Żurek", description: "Kyselá polévka na žitném kvasu s klobásou a vajíčkem" },
            { name: "Bigos", description: "Kysané zelí s masem - polský národní pokrm" }
          ]
        }
      ]
    },
    {
      flag: "🇪🇹",
      name: "Etiopie",
      vendors: [
        {
          name: "Etiopská kuchyně",
          dishes: [
            { name: "Injera", description: "Tradiční kvašený chléb, který slouží jako talíř i příbor" },
            { name: "Doro wat", description: "Pikantní kuřecí guláš s kořením berbere" },
            { name: "Kitfo", description: "Etiopský tatarák z hovězího masa s kořením" }
          ]
        }
      ]
    },
    {
      flag: "🐾",
      name: "Pro naše čtyřnohé přátele",
      vendors: [
        {
          name: "Fitmin Pestaurace",
          description: "První festivalová restaurace pro psy! Kvalitní pamlsky pro vaše domácí mazlíčky.",
          special: true
        }
      ]
    }
  ]
};

export const references = {
  title: "Úspěšná reference: Uherské Hradiště",
  event: "Gastrofestival Cesta Kolem Světa",
  edition: "4. ročník",
  statistics: {
    visitors: "10 000 návštěvníků",
    days: "2 dny",
    vendors: "40+ prodejců",
    satisfaction: "98% spokojených návštěvníků"
  },
  mediaReach: [
    "Televizní reportáže (ČT, TV Slovácko)",
    "Článek v regionálním tisku",
    "Sociální média: 50 000+ dosah",
    "Rádiové spoty (Frekvence 1, Evropa 2)"
  ],
  testimonials: [
    {
      quote: "Nejlepší gastro akce na Slovácku!",
      author: "Návštěvník festivalu 2026"
    },
    {
      quote: "Skvělá propagace města a regionu",
      author: "Místní podnikatel"
    }
  ]
};

export const budget = {
  title: "Finanční rozpočet akce",
  subtitle: "Transparentní přehled nákladů",
  
  totalCost: 204898, // 47500 + 40505 + 51677 + 65416
  cityContribution: 100000,
  cityPercentage: 50,
  
  categories: [
    {
      name: "Program a umělci",
      items: [
        { name: "Hadaš - vystupující", cost: 10000 },
        { name: "DJ Spike - vystupující", cost: 6500 },
        { name: "Bára Majíčková - moderace", cost: 10000 },
        { name: "Maxijedlík - vystupující", cost: 2000 },
        { name: "Honza Grebík - zpěvák", cost: 12000 },
        { name: "zpěvačka Alžběta Kolečkářová", cost: 7000 }
      ],
      subtotal: 47500
    },
    {
      name: "Technika a infrastruktura",
      items: [
        { name: "Ozvučení (OSA)", cost: 1508 },
        { name: "Technik - voda", cost: 677 },
        { name: "Zvukař - práce", cost: 7875 },
        { name: "Securiti služba", cost: 5280 },
        { name: "Elektrikář - dozor a rozchýlání kabeláže + balení", cost: 15000 },
        { name: "Pronájem centrály + PHM", cost: 10165 }
      ],
      subtotal: 40505
    },
    {
      name: "Propagace",
      items: [
        { name: "Facebook & sociální média", cost: 7160 },
        { name: "TV reklama (TV Slovácko)", cost: 7000 },
        { name: "Rádiová propagace - výroba spotu", cost: 3900 },
        { name: "Rádio Zlín - vysílání", cost: 3258 },
        { name: "Rádio Evropa 2 - vysílání", cost: 5803 },
        { name: "Rádio Frekvence 1 - vysílání", cost: 5425 },
        { name: "Billboard - pronájem plochy", cost: 6160 },
        { name: "Billboard - tisk plakátů", cost: 750 },
        { name: "Billboard - výlep plakátů", cost: 900 },
        { name: "Grafické práce a design", cost: 4000 },
        { name: "Propagační materiály - výroba", cost: 1015 },
        { name: "Energie a technické zajištění", cost: 3822 },
        { name: "Občerstvení pro účinkující a VIP", cost: 2484 }
      ],
      subtotal: 51677
    },
    {
      name: "Organizační náklady",
      items: [
        { name: "Tisk propagačních materiálů", cost: 22768 },
        { name: "Mobilní toalety (TOI TOI)", cost: 5850 },
        { name: "Odvoz odpadu", cost: 5906 },
        { name: "Personál - pomocné práce (2 dny)", cost: 6100 },
        { name: "Personál - technická podpora", cost: 9630 },
        { name: "Čistící prostředky", cost: 1216 },
        { name: "Dekorace a výzdoba prostoru", cost: 3200 },
        { name: "Výlep plakátů A1 (2 týdny)", cost: 1824 },
        { name: "Tisk voucherů pro partnery", cost: 359 },
        { name: "Ceny do soutěží a atrakce", cost: 1780 },
        { name: "Catering pro partnery a VIP", cost: 570 },
        { name: "Pronájem technického vybavení", cost: 1050 },
        { name: "Nákup vody pro personál", cost: 216 },
        { name: "Pomocný materiál a drobnosti", cost: 447 },
        { name: "Další organizační výdaje", cost: 4500 }
      ],
      subtotal: 65416
    }
  ],
  
  note: "Rozpočet vychází z reálných nákladů v roce 2025 Uherské Hradiště. V rozpočtu chybí položky vlastněné naší agenturou (podia apod.) - jedná se o transparentní vyčíslení čistých nákladů, bez úhrady našeho vybavení."
};

export const cityBenefits = {
  title: "Co město získá",
  subtitle: "Partnerství s přidanou hodnotou",
  
  benefits: [
    {
      title: "Hlavní pořadatel akce",
      description: "Město Luhačovice / Klub kultury bude uvedeno jako hlavní pořadatel na všech propagačních materiálech.",
      icon: "Award",
      highlights: [
        "Dominantní umístění loga města",
        "Zmínka ve všech mediálních výstupech",
        "Prezentace města jako moderního a aktivního"
      ]
    },
    {
      title: "Podpora cestovního ruchu",
      description: "Festival přiláká tisíce návštěvníků z okolních měst a regionů do Luhačovic.",
      icon: "TrendingUp",
      highlights: [
        "6 000 návštěvníků za 2 dny",
        "Průměrná doba pobytu: 3-4 hodiny",
        "Podpora místních restaurací, kaváren a obchodů",
        "Obsazení hotelů a ubytování"
      ]
    },
    {
      title: "Mediální pokrytí",
      description: "Rozsáhlá propagace s dosah desítek tisíc lidí.",
      icon: "Radio",
      highlights: [
        "Televizní reportáže",
        "Regionální tisk a online média",
        "Sociální média: 50 000+ dosah",
        "Rádiové spoty",
        "PR hodnota cca 200 000 Kč"
      ]
    },
    {
      title: "Kulturní obohacení města",
      description: "Kvalitní kulturní akce pro obyvatele i návštěvníky lázní.",
      icon: "Music",
      highlights: [
        "Zdarma pro všechny návštěvníky",
        "Rodinná atmosféra",
        "Podpora komunitního života",
        "Posilování značky Luhačovice jako kulturního centra"
      ]
    },
    {
      title: "Ekonomický přínos",
      description: "Stimulace místní ekonomiky během dvoudenní akce.",
      icon: "DollarSign",
      highlights: [
        "Odhad obratu cca 800 000 Kč",
        "Podpora místních podnikatelů",
        "Zvýšení tržeb restaurací o 30-50%",
        "Dlouhodobý efekt na image města"
      ]
    },
    {
      title: "Bezrizikové partnerství",
      description: "Ověřený koncept s garancí kvality.",
      icon: "ShieldCheck",
      highlights: [
        "4 roky zkušeností z Uherského Hradiště",
        "Profesionální tým organizátorů",
        "Komplexní pojištění akce",
        "Transparentní rozpočet a reporting"
      ]
    }
  ]
};

export const partnership = {
  title: "Partnerská nabídka",
  subtitle: "Společně vytvoříme nezapomenutelnou akce",
  
  totalBudget: "204 898 Kč",
  cityContribution: "100 000 Kč",
  percentage: "50% rozpočtu",
  
  whatCityGets: [
    "Hlavní pořadatel akce (dominantní logo)",
    "Mediální pokrytí v hodnotě 200 000 Kč",
    "6 000 návštěvníků v centru města",
    "Podpora cestovního ruchu a místní ekonomiky",
    "Kulturní obohacení pro obyvatele",
    "Profesionální realizace od A do Z"
  ],
  
  whatWeProvide: [
    "Kompletní organizaci akce",
    "Program a umělce",
    "Technické zajištění",
    "Propagaci a marketing",
    "Koordinaci prodejců",
    "Bezpečnost a hygienické zázemí",
    "Pojištění akce"
  ]
};

export const premiumOption = {
  title: "Tvář festivalu",
  subtitle: "Známé tváře pro spojení festivalu - dražší varianta 100-150 tis.",
  additionalCost: "100 000 - 150 000 Kč",
  note: "* Dodatečný náklad na vrub města.",
  
  benefits: [
    "Velký mediální dosah",
    "Prestiž akce"
  ],
  
  celebrities: [
    {
      name: "Zdeněk Pohlreich",
      description: "Největší hvězda gastro akcí, pravidelně na festivalech",
      icon: "Star"
    },
    {
      name: "Přemek Forejt",
      description: "MasterChef, moderní gastronomie",
      icon: "UtensilsCrossed"
    },
    {
      name: "Jan Punčochář",
      description: "Porotce MasterChef, často live cooking show",
      icon: "UtensilsCrossed"
    },
    {
      name: "Radek Kašpárek",
      description: "Michelinský šéfkuchař",
      icon: "Star"
    }
  ]
};

export const contactInfo = {
  name: "Jakub Vodárek",
  phone: "+420 774 750 456",
  email: "info@vseproakci.cz",
  company: "VšeProAkci.cz",
};

export const heroImage = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/3plv5bqw_fotka%20uvodni.jpg";

export const flyerImage = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/r46v3moy_priloha_1471068402_8_Gastrofestival_1000x2000_final_-scaled.jpg";

export const videoUrl = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/rcqy8dtp_reelgastrofest.mp4";

export const galleryImages = [
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/x1dbstzb_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.44.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/t2kem4gt_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.48.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/zn1ax9ph_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.52.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/4m7rwdu8_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.55.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/xh67drjq_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.30.00.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/l5eqkdpy_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.23.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/m24fql6z_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.26.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/ml60nwrw_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.31.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/nfhzs5l9_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.35.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/fs4qeafc_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.39.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/8jr0nhjt_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.57.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/vcdgus6e_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.00.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/o7rmnw37_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.04.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/23p7jwmc_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.07.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/sho6jiaz_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.29.18.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/sz4hn504_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.37.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/vgi57xca_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.41.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/v0nusus4_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.45.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/bxufhlkn_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.48.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/aiti0i29_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.52.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/6bk5ecaa_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.16.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/m2g9ycip_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.21.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/cyi3yrq9_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.26.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/aqkk7kku_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.30.png"
  },
  {
    url: "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/99ro9634_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A022.28.34.png"
  }
];

export const budgetImageUrl = "https://customer-assets.emergentagent.com/job_kontakt-gastro-hub/artifacts/l6cm553l_Sni%CC%81mek%20obrazovky%202026-04-09%20v%C2%A021.54.43.png";
